import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthenticationService } from '../../login/authentication.service';
import { ChangePasswordService } from './change-password.service';
import { T2LoadingService } from '../../../trip2-theme/components/t2-loading/t2-loading.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { constant } from 'app/app.constants';
import { PasswordValidator } from './password-validator';
import { Router } from '@angular/router';
import { checkValid } from '../export-functions/functions-services';
import { SweetAlertHelper } from '../../../core/helpers/sweet-alert-helper.service';
import { ParentModule } from '../ParentClass/parent-module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  @Input() changePasswordUser;
  @Input() token;
  @Input() userprofileid: any;
  @Output() onCloseModal: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() onSuccessChange: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Input() userEmail: any;
  @Input() enforcePassword: boolean;
  @Input() nonAdminChange: boolean = false;
  @Input() viewUser = false;

  private manualPasswordChange = true;
  private sendingEmail = true;
  private msgEmail: any;
  private subscrip: Subscription[] = [];
  isPasswordChange = false;

  changePassForm: FormGroup;

  constructor(
    private _services: ChangePasswordService,
    private authenticationService: AuthenticationService,
    protected _loading: T2LoadingService,
    fb: FormBuilder,
    private router: Router,
    private sweetAlertHelper: SweetAlertHelper,
     protected Inject: Injector,
  ) {
    super('app-users', Inject);
    this.changePassForm = fb.group({
      password: [null, Validators.compose([Validators.required, Validators.minLength(8)])],
      confirmpassword: [null, Validators.required],
      reenterpassword: true ,
      manualpasswordchage: true,
      userprofileid: null,
      token: null,
      newpassword: null
    }, {
      validator: PasswordValidator.passwordMatch()
    });
    this.subscrip.push(
      this.actionsList$.subscribe((resp: any) => {
        if (resp && resp.length) {
          this.isPasswordChange = resp.includes('Password Change Required');
        }
      })
    );
  }

    ngOnInit() {
    if (this.nonAdminChange || this.enforcePassword) {
      this.manualPasswordChange = false;
    }

    if (this.enforcePassword) {
      this.changePassForm.get('password').setValidators(Validators.compose([
        Validators.required,
        PasswordValidator.pattern(/\d/, { hasNumber: true }),
        PasswordValidator.pattern(/[A-Z]/, { hasCapitalCase: true }),
        PasswordValidator.pattern(/[a-z]/, { hasSmallCase: true }),
        PasswordValidator.pattern(/[!%&'()*+./;<=>?\\,/:#@\t\r\n"\[\]_\u007B-\u00BF-]/, { hasSpecialCharacters: true }),
        Validators.minLength(constant.ENFORCED_PASSWORD_MIN_LENGTH)
      ]));
      }




  }



  /**
   * this validate if password contain an error
   * @param error
   */
  validateError(error): boolean {
    return this.changePassForm.controls['password'].hasError('required') ||
    this.changePassForm.controls['password'].hasError(error);
  }

  iconValid(valid: boolean) {
    return checkValid(valid);
  }
  /**
   * @name submit
   * @description
   */
  submit() {
    if (this.manualPasswordChange) {
      this.automaticChangePassword();
    } else {
      this.onChangePassword();
    }
  }

  /**
   * @name onChangePassword
   * @description
   */
  onChangePassword() {
    this._loading.show();
    this.changePassForm.patchValue({
      userprofileid: this.userprofileid
    });
    this.subscrip.push(
    this._services
      .changePassword(this.changePassForm.value)
      .finally(() => {
        this._loading.hiden();
      })
      .subscribe(
      data => {
        if (data.success) {
          this.onSuccessChange.emit(data.message);
          this.CloseModal();
        }
      }, error => {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Password',
          text: error.message,
          type: 'error',
        });
        this.resetPassword();
      }
    ));
  }


  newChangePassword() {
    this.changePassForm.patchValue({
      userprofileid: this.userprofileid,
      token: this.token,
      newpassword: this.changePassForm.get('password').value,
    });


    this.subscrip.push(
    this._services
      .newChangePassword(this.changePassForm.value)
      .subscribe({
        next: (data) => {
          if (data && data.success) {
            this.onSuccessChange.emit(data.message);
            this.router.navigate(['/auth/login']);
          }
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error.message);
        },
      }));
      this.changePassForm.reset();
  }

  /**
   * @name automaticChangePassword
   * @description
   */
  automaticChangePassword() {
    this.msgEmail = 'Please Wait...';
    this.sendingEmail = false;
    this.subscrip.push(
    this.authenticationService.rememberPassword(this.userEmail)
      .subscribe(
        data => {
          this.msgEmail = `User will receive an e-mail from us with instructions for resetting your password.
            If you do not receive this e-mail please check your junk mail folder or contact our customer
            service team for further assistance.`;
          this.sendingEmail = true;
          this.onSuccessChange.emit(data.message);

        },
        error => {
          this.sendingEmail = true;
          this.sweetAlertHelper.createCustomAlert({
            title: 'Attention',
            text: error.message,
            type: 'error',
          });
        }
      ));
  }

  /**
   * @name CloseModal
   * @description
   */
  CloseModal() {
    this.onCloseModal.emit(true);
  }

  /**
   * @name resetPassword
   * @description reset campos de password
   */
  resetPassword() {
    this.changePassForm.patchValue({
      password: null,
      confirmpassword: null
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnDestroy(): void {
    if (this.subscrip && this.subscrip.length) {
       this.subscrip.forEach(sub => sub.unsubscribe());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-password/change-password.component.ts